export enum ChapterTypes {
  PRE_TEXTUAL = 1,
  CAPITULO = 3,
  POS_TEXTUAL = 2
}
